import React from 'react';
import PropTypes from 'prop-types';
import Popup from '../Base/Popup';
import Translation from '../Base/Translation';
import Button from '../Base/Button';
import style from '@src/js/Style';
import NumberFormatter from '../../NumberFormatter';
import RangeCollection from '../Form/RangeCollection';
import AmortizationScheduleTable from './AmortizationScheduleTable';
import EarlyPayment from './EarlyPayment';
import ReportQuery from './ReportQuery';
import MortgageForm from './MortgageForm';

export default class AmortizationSchedule extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = { popup: null };
        
        this.state = this
            .getMortgageForm()
            .getState();

        this
            .getMortgageForm()
            .load()
            .then((response) => this.setState(response.state));
    }

    getMortgageForm() {

        return this.props.form;
    }
    
    static get propTypes() {

        return {
            table: PropTypes.instanceOf(AmortizationScheduleTable),
            report: PropTypes.instanceOf(ReportQuery),
            form: PropTypes.instanceOf(MortgageForm),
            showResult: PropTypes.func,
            getEarlyPaymentForm: PropTypes.func,
        };
    }

    //------------------------------------------------------------------------------------------------------------------
    // INIT
    //------------------------------------------------------------------------------------------------------------------

    componentDidMount() {

        this.update(0);
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        const title = <Translation tag='calc.amortization.title' />;

        return (<>
            {/* main popup */}
            <Popup title={ title } ref={ (node) => { this.nodes.popup = node; } }>

                <div className={ style('flex flex-wrap w-full') }>

                    {/* calculator query details */}
                    <div className={ style('flex-grid-4 flex-1 mobile:w-full gap justify-between items-stretch') }>

                        { this.renderDetail(this.state.rate) }
                        { this.renderDetail(this.state.result.creditBody) }
                        { this.renderDetail(this.state.term) }
                        { this.renderDetail(this.state.result.creditOverpayment, this.props.currency) }

                    </div>

                    {/* button - add early payment */}
                    <div className={ style('flex items-end w-full desktop:size-320') }>
                        <Button
                            className={ style('mt-4 w-full') }
                            onClick={ () => this.addEarlyPaymentEvent() }>
                                <i className={ style('icon-plus-circle') }></i>
                                <Translation tag='calc.amortization.addEarlyPayment' />
                        </Button>
                    </div>

                </div>

                <div className={ style('flex-grid-2') }>

                    { this.renderRangeContainer() }
                    { this.renderEarlyPayment() }

                </div>

                <div className={ style('flex mobile:flex-wrap gap mt-4 justify-between') }>
                
                    {/* checkbox */}
                    <div></div>

                    <div className={ style('flex mobile:flex-wrap gap mobile:w-full') }>

                        {/* <span className={ style('mobile:w-full flex items-center gap-md cursor-pointer') }>
                            <Translation tag='calc.amortization.download' />
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.52708 10.5263L7.66708 11.3929V7.66627C7.66708 7.48946 7.59684 7.31989 7.47182 7.19487C7.3468 7.06984 7.17723 6.9996 7.00041 6.9996C6.8236 6.9996 6.65403 7.06984 6.52901 7.19487C6.40399 7.31989 6.33375 7.48946 6.33375 7.66627V11.3929L5.47375 10.5263C5.41159 10.4641 5.3378 10.4148 5.25658 10.3812C5.17537 10.3475 5.08832 10.3302 5.00041 10.3302C4.91251 10.3302 4.82546 10.3475 4.74425 10.3812C4.66303 10.4148 4.58924 10.4641 4.52708 10.5263C4.46492 10.5884 4.41562 10.6622 4.38197 10.7434C4.34833 10.8247 4.33102 10.9117 4.33102 10.9996C4.33102 11.0875 4.34833 11.1746 4.38197 11.2558C4.41562 11.337 4.46492 11.4108 4.52708 11.4729L6.52708 13.4729C6.59048 13.5336 6.66525 13.5812 6.74708 13.6129C6.82688 13.6482 6.91317 13.6664 7.00041 13.6664C7.08766 13.6664 7.17395 13.6482 7.25375 13.6129C7.33558 13.5812 7.41035 13.5336 7.47375 13.4729L9.47375 11.4729C9.59928 11.3474 9.66981 11.1771 9.66981 10.9996C9.66981 10.8221 9.59928 10.6518 9.47375 10.5263C9.34821 10.4007 9.17795 10.3302 9.00041 10.3302C8.82288 10.3302 8.65262 10.4007 8.52708 10.5263ZM11.2804 3.14627C10.8731 2.21027 10.1701 1.43366 9.27913 0.935422C8.38819 0.437189 7.35845 0.244826 6.34773 0.387811C5.337 0.530795 4.40103 1.00124 3.68325 1.72705C2.96547 2.45287 2.50547 3.39401 2.37375 4.40627C1.73814 4.55849 1.18056 4.93883 0.806907 5.47506C0.433251 6.0113 0.269538 6.66609 0.346858 7.31508C0.424177 7.96407 0.737145 8.56207 1.22633 8.99551C1.71551 9.42895 2.34683 9.66765 3.00042 9.66627C3.17723 9.66627 3.3468 9.59603 3.47182 9.47101C3.59684 9.34599 3.66708 9.17642 3.66708 8.99961C3.66708 8.82279 3.59684 8.65322 3.47182 8.5282C3.3468 8.40318 3.17723 8.33294 3.00042 8.33294C2.64679 8.33294 2.30765 8.19246 2.05761 7.94241C1.80756 7.69237 1.66708 7.35323 1.66708 6.9996C1.66708 6.64598 1.80756 6.30684 2.05761 6.0568C2.30765 5.80675 2.64679 5.66627 3.00042 5.66627C3.17723 5.66627 3.3468 5.59603 3.47182 5.47101C3.59684 5.34598 3.66708 5.17642 3.66708 4.9996C3.66878 4.21112 3.94994 3.44877 4.46059 2.84799C4.97125 2.24721 5.67834 1.84691 6.45625 1.71819C7.23415 1.58947 8.0325 1.74068 8.70946 2.14494C9.38642 2.54921 9.89815 3.18036 10.1537 3.92627C10.1919 4.04083 10.2604 4.14289 10.3519 4.22156C10.4435 4.30023 10.5548 4.35255 10.6737 4.37294C11.1178 4.45685 11.5203 4.68867 11.8158 5.03063C12.1112 5.37258 12.2821 5.80451 12.3007 6.25603C12.3192 6.70755 12.1843 7.15205 11.9179 7.51709C11.6516 7.88214 11.2694 8.1462 10.8337 8.26627C10.7488 8.28816 10.669 8.32656 10.599 8.37928C10.5289 8.432 10.4699 8.498 10.4253 8.57353C10.3807 8.64905 10.3515 8.73262 10.3392 8.81945C10.3269 8.90628 10.3319 8.99468 10.3537 9.07961C10.3756 9.16453 10.414 9.24431 10.4668 9.31439C10.5195 9.38447 10.5855 9.44348 10.661 9.48805C10.7365 9.53262 10.8201 9.56188 10.9069 9.57416C10.9938 9.58644 11.0822 9.58149 11.1671 9.5596C11.8687 9.37421 12.4906 8.96493 12.9384 8.39392C13.3862 7.8229 13.6355 7.12134 13.6483 6.39578C13.6611 5.67022 13.4368 4.9603 13.0095 4.37382C12.5821 3.78734 11.975 3.35634 11.2804 3.14627Z" fill="#1373E5"/></svg>
                        </span> */}

                        <span
                            onClick={ () => this.props.showResult() }
                            className={ style('mobile:w-full flex items-center gap-md cursor-pointer text-primary') }>
                                <Translation tag='calc.amortization.table' />
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.66732 12.334H1.66732V12.2673C1.66732 11.934 1.93398 11.6673 2.26732 11.6673C3.20065 11.6673 4.00065 11.0673 4.26732 10.2007C4.53398 9.13398 3.93398 8.00065 2.86732 7.73398C2.00065 7.46732 1.06732 7.86732 0.600651 8.66732C0.400651 9.00065 0.533984 9.40065 0.867318 9.60065C1.20065 9.80065 1.60065 9.66732 1.80065 9.33398C2.00065 9.00065 2.40065 8.93398 2.73398 9.13398C2.80065 9.20065 2.86732 9.20065 2.86732 9.26732C3.00065 9.46732 3.00065 9.66732 3.00065 9.86732C2.86732 10.134 2.60065 10.334 2.33398 10.334C1.20065 10.334 0.333984 11.2007 0.333984 12.2673V13.0007C0.333984 13.4007 0.600651 13.6673 1.00065 13.6673H3.66732C4.06732 13.6673 4.33398 13.4007 4.33398 13.0007C4.33398 12.6007 4.06732 12.334 3.66732 12.334ZM3.66732 5.00065H3.00065V1.00065C3.00065 0.600651 2.73398 0.333984 2.33398 0.333984C1.93398 0.333984 1.66732 0.600651 1.66732 1.00065V1.66732H1.00065C0.600651 1.66732 0.333984 1.93398 0.333984 2.33398C0.333984 2.73398 0.600651 3.00065 1.00065 3.00065H1.66732V5.00065H1.00065C0.600651 5.00065 0.333984 5.26732 0.333984 5.66732C0.333984 6.06732 0.600651 6.33398 1.00065 6.33398H3.66732C4.06732 6.33398 4.33398 6.06732 4.33398 5.66732C4.33398 5.26732 4.06732 5.00065 3.66732 5.00065ZM6.33398 3.00065H13.0007C13.4007 3.00065 13.6673 2.73398 13.6673 2.33398C13.6673 1.93398 13.4007 1.66732 13.0007 1.66732H6.33398C5.93398 1.66732 5.66732 1.93398 5.66732 2.33398C5.66732 2.73398 5.93398 3.00065 6.33398 3.00065ZM13.0007 12.334H6.33398C5.93398 12.334 5.66732 12.6007 5.66732 13.0007C5.66732 13.4007 5.93398 13.6673 6.33398 13.6673H13.0007C13.4007 13.6673 13.6673 13.4007 13.6673 13.0007C13.6673 12.6007 13.4007 12.334 13.0007 12.334ZM13.0007 5.00065H6.33398C5.93398 5.00065 5.66732 5.26732 5.66732 5.66732C5.66732 6.06732 5.93398 6.33398 6.33398 6.33398H13.0007C13.4007 6.33398 13.6673 6.06732 13.6673 5.66732C13.6673 5.26732 13.4007 5.00065 13.0007 5.00065ZM13.0007 9.00065H6.33398C5.93398 9.00065 5.66732 9.26732 5.66732 9.66732C5.66732 10.0673 5.93398 10.334 6.33398 10.334H13.0007C13.4007 10.334 13.6673 10.0673 13.6673 9.66732C13.6673 9.26732 13.4007 9.00065 13.0007 9.00065Z" fill="#1373E5"/></svg>
                        </span>

                    </div>

                </div>

            </Popup>

        </>);
    }

    renderEarlyPayment() {

        const earlyPaymentsElements = this.props.table
            .getEarlyPayments()
            .map((earlyPayment, index) => {
            
                return <EarlyPayment
                    key={ index }
                    report={ this.props.report }
                    payment={ NumberFormatter.parse(earlyPayment.value, 0) }
                    description={ earlyPayment.desc }
                    details={ earlyPayment.details }
                    nonce={ earlyPayment.nonce }
                    />
            });

        return (
            <div className={ style('rounded bg-gray-light-alt mt-8 p-4 gap-lg flex flex-wrap') }>

                {/* block title and duplicate append button */}
                <div className={ style('flex justify-between items-center w-full') }>
                    <div className={ style('title4') }>
                        <Translation tag='calc.earlyPayment.title' />
                    </div>
                    <i
                        className={ style('text-primary icon-plus-circle cursor-pointer title3') }
                        onClick={ () => this.addEarlyPaymentEvent() } />
                </div>

                { earlyPaymentsElements }

            </div>
        );
    }

    renderRangeContainer() {

        return (
            <div className={ style('rounded bg-gray-light-alt mt-8 p-4') }>
                
                {/* block title */}
                <div className={ style('title4') }>{ this.state.result.payment.label }</div>
                <div className={ style('flex gap items-center mt-6 mb-6') }>

                    {/* payment */}
                    <div className={ style('title3') }>
                        { this.state.result.payment.value.formatted() }
                    </div>

                    { this.renderExtraPayment() }

                </div>

                <div className={ style('flex mobile:flex-wrap gap mobile:justify-between') }>
                    <div className={ style('mobile:w-6/12') }>{ this.state.result.paymentCreditBody.label }:</div>
                    <div className={ style('text-bold text-success') }>
                        { this.state.result.paymentCreditBody.value.formatted() }
                    </div>

                    <div className={ style('mobile:w-6/12') }>{ this.state.result.paymentOverpayment.label }:</div>
                    <div className={ style('text-bold text-warning') }>
                        { this.state.result.paymentOverpayment.value.formatted() }
                    </div>
                </div>

                <div className={ style('flex flex-wrap gap justify-between mt-6') }>

                    <div className={ style('mobile:w-full') }>{ this.state.date }</div>

                    <div className={ style('mobile:w-full flex gap justify-between') }>
                        <Translation tag='calc.amortization.endingBalanceLabel' />
                        <div className={ style('text-bold whitespace-nowrap') }>
                            { this.state.endingBalance?.formatted() }
                        </div>
                    </div>

                </div>
                
                {/* slider */}
                { this.renderRange() }

                <div className={ style('flex flex-wrap gap justify-between mt-8') }>
                    { this.renderPrev() }
                    { this.renderNext() }
                </div>


            </div>
        );
    }

    renderExtraPayment() {

        if (this.state.extraPayment == undefined)
            return null;

        return (
            <div className={ style('flex gap-sm items-center') }>
                +
                <div>{ this.state.extraPayment.formatted() }</div>
                {/* <Tooltip className={ style('ml-0') }>text?</Tooltip> */}
            </div> 
        );
    }

    renderRange() {

        if (this.props.table == undefined)
            return null;

        return (
            <div className={ style('mt-8 mb-8') }>
                <RangeCollection
                    ref={ (node) => { this.nodes.range = node; } }
                    collection={ this.props.table.getRows() }
                    prefix={ this.props.table.getFirstPaymentDate().getFullYear() }
                    suffix={ this.props.table.getLastPaymentDate().getFullYear() }
                    onChange={ (e) => this.rangeChangeEvent(e) }
                    />
            </div>
        );
    }

    renderPrev() {

        if (!this.state.prevMonth)
            return <div></div>;

        return (
            <div className={ style('flex-center gap-sm cursor-pointer') } onClick={ () => this.prevMonth() }>
                <i className={ style('icon-arrow-down-strong rotate-90 text-primary') }></i>
                { this.state.prevMonth }
            </div>
        );
    }

    renderNext() {

        if (!this.state.nextMonth)
            return <div></div>;

        return (
            <div className={ style('flex-center gap-sm cursor-pointer') } onClick={ () => this.nextMonth() }>
                { this.state.nextMonth }
                <i className={ style('icon-arrow-down-strong rotate-270 text-primary') }></i>
            </div>
        );
    }

    renderDetail(props, suffix = null) {

        if (!props)
            return null;

        return (
            <div className={ style('flex flex-wrap mobile:grid-2 gap justify-between items-stretch w-full') }>

                <div className={ style('w-full text-muted text-medium') }>
                    { props.label }
                </div>

                <div className={ style('title4 flex flex-wrap desktop:items-end whitespace-nowrap') }>

                    { this.renderNewDetail(props) }

                    <span className={ props?.newValue ? style('line-through') : null }>
                        { NumberFormatter.parse(props.value, null, suffix).formatted() }
                    </span>

                </div>

            </div>
        )
    }

    renderNewDetail(props, suffix) {

        if (!props?.newValue)
            return null;

        return (
            <span className={ style('text-success w-full') }>
                { NumberFormatter.parse(props.newValue, null, suffix).formatted() }
            </span>
        );
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACTIONS
    //------------------------------------------------------------------------------------------------------------------

    show() {

        this.update(this.state.value ?? 0);
        this.nodes.popup.show();
    }

    hide() {

        this.nodes.popup.hide();
    }

    prevMonth() {

        this.update(this.state.prevMonthId, true);
    }

    nextMonth() {

        this.update(this.state.nextMonthId, true);
    }

    update(index, updateValue = false) {

        index = parseInt(index);

        const
            rows = this.props.table.getRows(),
            selected = rows[index];

        if (selected == undefined)
            throw new Error(`Unknown index: ${index}`);

        this.state.endingBalance = selected.endingBalance;
        this.state.date = `${selected.paymentDate.getFullMonth()} ${selected.paymentDate.getFullYear()}`;

        this.state.prevMonthId = index - 1;
        this.state.prevMonth = rows[this.state.prevMonthId]
            ? rows[this.state.prevMonthId].paymentDate.getFullMonth()
            : null;

        this.state.nextMonthId = index + 1;
        this.state.nextMonth = rows[this.state.nextMonthId]
            ? rows[this.state.nextMonthId].paymentDate.getFullMonth()
            : null;

        this.state.result.paymentCreditBody.value.set(selected.paymentWithoutPercent);
        this.state.result.paymentOverpayment.value.set(selected.paymentPercent);
        this.state.result.payment.value.set(selected.payment);
            
        this.setState({
            result: this.state.result,
            date: this.state.date,
            endingBalance: NumberFormatter.parse(this.state.endingBalance, 0, this.props.currency),
            prevMonth: this.state.prevMonth,
            nextMonth: this.state.nextMonth,
            extraPayment: NumberFormatter.parse(selected.earlyPayment).toInt() > 0
                ? NumberFormatter.parse(selected.earlyPayment, 0, this.props.currency)
                : null,
        });

        if (updateValue)
            this.nodes.range.setValue(index);
    }

    //------------------------------------------------------------------------------------------------------------------
    // EVENTS
    //------------------------------------------------------------------------------------------------------------------

    rangeChangeEvent(e) {
        
        this.state.value = e.detail.value;
        this.update(this.state.value);
    }

    addEarlyPaymentEvent() {

        this.props.getEarlyPaymentForm().show();
    }

}